import { LiksPagination } from '../../components/liks/LiksPagination/LiksPagination';
import { LiksPage } from '../../components/liks/LiksPage/LiksPage';
import { LiksRefreshButton } from '../../components/liks/LiksRefreshButton/LiksRefreshButton';
import { LiksSearch } from '../../components/liks/LiksSearch/LiksSearch';
import { useGalleryPage } from '../../features/gallery/hooks/useGalleryPage';
import { useI18n } from '../../i18n/useI18n';
import { GALLERY_PAGE_SIZES } from '../../types/userConfig';
import { GalleryImageCard } from './GalleryImageCard';
import './GalleryPage.css';

export function GalleryPage() {
  const { translate } = useI18n();
  const {
    images,
    galleryPage,
    searchInput,
    hasActiveGallerySearch,
    handleSearchChange,
    setGalleryPage,
    handleManualRefresh,
    hasPreviousGalleryPage,
    hasNextGalleryPage,
    galleryImagesPageSize,
    handleGalleryPageSizeChange,
    isPageLoading,
  } = useGalleryPage();

  const showEmptyState = !isPageLoading && images.length === 0;
  const emptyMessage =
    hasActiveGallerySearch || galleryPage > 1
      ? translate('gallery.noResults')
      : translate('gallery.empty');

  return (
    <LiksPage
      header={
        <div className="gallery-page__header">
          <h1>{translate('gallery.title')}</h1>
          <div className="gallery-page__toolbar">
            <LiksSearch
              className="gallery-page__search"
              variant="on-light"
              value={searchInput}
              onChange={handleSearchChange}
              placeholder={translate('gallery.searchPlaceholder')}
              aria-label={translate('gallery.searchLabel')}
              clearLabel={translate('common.search.clear')}
            />
            <LiksRefreshButton
              className="gallery-page__refresh-button"
              onRefresh={handleManualRefresh}
            />
          </div>
        </div>
      }
      content={
        <div className="gallery-page__content">
          {isPageLoading ? (
            <p className="gallery-page__empty">
              {translate('gallery.loading')}
            </p>
          ) : showEmptyState ? (
            <p className="gallery-page__empty">{emptyMessage}</p>
          ) : (
            <div className="gallery-page__grid">
              {images.map((image) => (
                <GalleryImageCard
                  key={image.id}
                  image={image}
                  downloadLabel={translate('platformChat.downloadImage')}
                  expandLabel={translate('platformChat.expandImage')}
                  deleteLabel={translate('gallery.deleteImage')}
                  deleteConfirmTitle={translate('gallery.deleteConfirmTitle')}
                  deleteConfirmMessage={translate(
                    'gallery.deleteConfirmMessage',
                  )}
                  deleteConfirmAction={translate('gallery.deleteConfirmAction')}
                  deleteCancelAction={translate('gallery.deleteConfirmCancel')}
                  closePreviewLabel={translate(
                    'platformChat.closeImagePreview',
                  )}
                  loadingLabel={translate('platformChat.imageLoading')}
                  imageAltFallback={translate('gallery.imageAltFallback')}
                />
              ))}
            </div>
          )}
        </div>
      }
      footer={
        <div className="gallery-page__footer">
          <LiksPagination
            page={galleryPage}
            pageSize={galleryImagesPageSize}
            pageSizes={GALLERY_PAGE_SIZES}
            onPageSizeChange={(size) =>
              handleGalleryPageSizeChange(String(size))
            }
            hasPreviousPage={hasPreviousGalleryPage}
            hasNextPage={hasNextGalleryPage}
            onPreviousPage={() => setGalleryPage(Math.max(1, galleryPage - 1))}
            onNextPage={() => {
              if (hasNextGalleryPage) {
                setGalleryPage(galleryPage + 1);
              }
            }}
          />
        </div>
      }
    />
  );
}
